export default __webpack_public_path__ + "static/crystal_roadmap-48daeadc3afe1d90b51fd5e823f33c9f.png";